import React from 'react';

import {
  constants,
  removeInArrayByIndex,
  insertInArrayByIndex,
  isEmptyCollection,
} from '@atlas/core';

const initialSelectedBonusesState = [];

const selectedBonusesReducer = (state, action) => {
  if (action.type === 'select') {
    if (isEmptyCollection(action.payload)) {
      return state;
    }

    const bonusIndex = state.findIndex(bonus => bonus.id === action.payload.id);

    if (bonusIndex >= 0) {
      return removeInArrayByIndex(state, bonusIndex);
    }

    const bonusTypeIndex = state.findIndex(bonus => bonus.bonusType === action.payload.bonusType);

    if (bonusTypeIndex >= 0) {
      return insertInArrayByIndex(state, bonusTypeIndex, action.payload);
    }

    return [...state, action.payload];
  }

  if (action.type === 'reset') {
    return initialSelectedBonusesState;
  }

  return state;
};

export default function useSelectedBonuses() {
  const [selectedBonuses, dispatch] = React.useReducer(
    selectedBonusesReducer,
    initialSelectedBonusesState,
  );

  const removeSelectedBonuses = React.useCallback(() => dispatch({ type: 'reset' }), []);

  const selectBonus = React.useCallback(
    payload =>
      dispatch({
        type: 'select',
        payload,
      }),
    [],
  );

  const selectedFreebet = React.useMemo(
    () => selectedBonuses.find(bonus => bonus.bonusType === constants.BONUS_TYPE.FREEBET),
    [selectedBonuses],
  );

  return {
    selectedBonuses,
    selectBonus,
    selectedFreebet,
    removeSelectedBonuses,
  };
}
